"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 使用全局的方式记录当前是否在拖拽……
let dndArray = "";
let dndFrom = 0;
let dndTo = 0;

const transparentImage = document.createElement("img");
transparentImage.src =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

exports. default = {
  name: "array-table-row",
  components: {
    DataFormField: () => Promise.resolve().then(() => _interopRequireWildcard(require("../../DataFormField"))).then((x) => x.default),
  },
  props: {
    index: Number,
    readonly: Boolean,
    arrayStub: Object,
    disableDrag: { type: Boolean, default: false },
    disableDelete: { type: Boolean, default: false },
    hideNumber: { type: Boolean, default: false },
    cols: Array,

    /** 用于拖拽排序的 */
    arrayUuid: String,
  },

  // events: 见 react 的 arrayTableRow

  computed: {
    stub() {
      const { arrayStub, index } = this;
      return arrayStub.getChildStub(index);
    },
  },

  data() {
    return {
      dnd: {
        /** 当前是否可被拖拽 */
        draggable: false,

        /** 是否在拖拽过程中，鼠标在这一行上 */
        over: false,
      },
      dndFrom: 0,
    };
  },

  methods: {
    handleDragStart(ev) {
      const { arrayUuid, index, dnd, readonly } = this;

      if (ev.target !== ev.currentTarget) return;

      if (!dnd.draggable || readonly) {
        ev.preventDefault();
        return;
      }

      dndArray = arrayUuid;
      dndFrom = index;
      dndTo = index;
      dnd.over = true;

      this.$emit("moveStart");

      // 去掉拖拽的那个半透明鬼影

      ev.dataTransfer.setDragImage(transparentImage, 0, 0);
      ev.dataTransfer.dropEffect = "move";
      ev.dataTransfer.effectAllowed = "move";
      ev.stopPropagation();
    },

    handleDragOver(ev) {
      const { arrayUuid, index, dnd } = this;
      this.dndFrom = dndFrom; // 非响应式的变量

      if (dndArray !== arrayUuid) return;
      if (dndTo !== index) {
        dndTo = index;
        dnd.over = true;
      }

      // 接受drop
      ev.preventDefault();
      ev.stopPropagation();
      return false;
    },

    handleDragLeave(ev) {
      const { arrayUuid, index, dnd } = this;

      if (dndArray !== arrayUuid) return;
      if (dndTo === index) dndTo = -1;

      dnd.over = false;
    },

    handleDragEnd(ev) {
      const { dnd } = this;

      dndArray = "";
      dnd.over = false;

      ev.preventDefault();
      this.$emit("moveEnd");
    },

    handleDrop(ev) {
      const { arrayUuid, index, dnd } = this;

      if (dndArray !== arrayUuid) return;
      if (dndFrom !== dndTo) {
        this.$emit("moveItem", {
          from: dndFrom,
          to: index,
        });
      }
      dnd.over = false;
    },

    handleNumberMouseEnter() {
      const { dnd } = this;
      dnd.draggable = true;
    },
    handleNumberMouseOut() {
      const { dnd } = this;
      dnd.draggable = false;
    },
  },
};

;(function(options){
  var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      staticClass: "ds-arrayTable-row",
      class:
        (_vm.dnd.over &&
          (_vm.index >= _vm.dndFrom
            ? "dnd-insert-after"
            : "dnd-insert-before")) ||
        "",
      attrs: {
        draggable: _vm.dnd.draggable && !_vm.readonly && !_vm.disableDrag
      },
      on: {
        dragstart: _vm.handleDragStart,
        dragover: _vm.handleDragOver,
        dragleave: _vm.handleDragLeave,
        dragend: _vm.handleDragEnd,
        drop: _vm.handleDrop
      }
    },
    [
      !_vm.hideNumber
        ? _c(
            "td",
            {
              staticClass: "ds-arrayTable-number",
              on: {
                mouseenter: _vm.handleNumberMouseEnter,
                mouseout: _vm.handleNumberMouseOut
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.index + 1) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.cols, function(col, idx) {
        return _c(
          "td",
          { key: idx },
          [
            _c("DataFormField", {
              attrs: {
                internalParentStub: _vm.stub,
                path: col.id,
                readonly: _vm.readonly || col.readonly,
                label: false
              }
            })
          ],
          1
        )
      }),
      _vm._v(" "),
      !_vm.readonly && !_vm.disableDelete
        ? _c("td", { staticClass: "ds-arrayTable-operation" }, [
            _c(
              "button",
              {
                staticClass: "ds-arrayTable-delete",
                attrs: { disabled: _vm.readonly },
                on: {
                  click: function($event) {
                    return _vm.$emit("delete", _vm.index)
                  }
                }
              },
              [_vm._v("删除")]
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


  options.render = render
  options.staticRenderFns = staticRenderFns
  options._compiled = true
})(exports.default);
